module.exports = __webpack_public_path__ + "img/project-26.bf155adb.png";